import { render } from "./SaveToCollectionChooser.vue.js?vue&type=template&id=2e08d9c4!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooser.vue?vue&type=template&id=2e08d9c4"
import script from "./SaveToCollectionChooser.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooser.vue?vue&type=script&lang=js"
export * from "./SaveToCollectionChooser.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/saved-posts/SaveToCollectionChooser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e08d9c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e08d9c4', __exports__)) {
    api.reload('2e08d9c4', __exports__)
  }
  
  module.hot.accept("./SaveToCollectionChooser.vue.js?vue&type=template&id=2e08d9c4!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SaveToCollectionChooser.vue?vue&type=template&id=2e08d9c4", () => {
    api.rerender('2e08d9c4', render)
  })

}


export default __exports__